<template>
  <div id="sign">
    <div class="row mt-md-5">
      <div class="col-md-12 title">
        <h1>Zoomサイン会について</h1>
      </div>
      <div class="col-md-12 description">
        <p>
          読み聞かせの後、Zoomで絵本作家とお話しながらサイン会を行います。サイン会を希望する方は、参加申込フォームの「Zoomで作家とお話しつき絵本のサイン希望」にチェックをお願いいたします。
        </p>
      </div>

      <div class="col-md-12 how-to-download tanetane-sign">
        <h2>
          本のご購入方法
        </h2>

        <p>
          事前にこちらのおかいものサイトから (<a href="https://okaimono.ohisamak-ehonya.com/" target="_blank">https://okaimono.ohisamak-ehonya.com/</a>)「Zoomで作家のサインつき絵本」を選択し、購入決済をお願いいたします。当日、作家がサインをし、後日ご自宅へお送りさせていただきます。
        </p>

        <h2>
          金額
        </h2>

        <p>
          絵本、1冊1404円です。
        </p>

        <h2>
          サイン会の時間・順番
        </h2>

        <p>
          ひと組さま約5分とさせていただきます。絵本のご購入後、個別にサイン会の時間をメールにてお知らせいたします。
         サイン会の順番は、「BASE」で絵本をお買いげいただいた順番になります。順番・サイン会開始時間は前日までに、メールでご連絡いたします。
        </p>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    title: 'Zoomサイン会について',
    name: 'sign',
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sign.vue